module.exports = __webpack_public_path__ + "static/media/audiobg.ba58203c.png";